var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchInsights = function SvgSearchInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E9F1FF",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#92B7FF",
    d: "M8.8 12.4q1.5 0 2.55-1.05T12.4 8.8t-1.05-2.55T8.8 5.2 6.25 6.25 5.2 8.8t1.05 2.55T8.8 12.4m-.6-1.8V6.4h1.2v4.2zm-2.1 0v-3h1.2v3zm4.2 0V8.2h1.2v2.4zm4.86 5.4-3.405-3.405A4.76 4.76 0 0 1 8.8 13.6q-2.01 0-3.405-1.395T4 8.8t1.395-3.405T8.8 4t3.405 1.395T13.6 8.8q0 .84-.262 1.59-.263.75-.743 1.365L16 15.16z"
  })));
};
export default SvgSearchInsights;